import AbstractRequestTask from '../AbstractRequestTask';
import Launcher from '../../apa/Launcher';

class OffersTask extends AbstractRequestTask {
    constructor(uri) {
        super();
        this.uri = uri;
        this.params = {};
    }

    getUrl() {
        const http = "http://";
        const url = Launcher.get("akamai_mfwk");

        return `${http}${url}${this.uri.slice(1)}`;
    }

    getParams() {
        const params = super.getParams();
        delete params.api_version;
        delete params.HKS;
        delete params.authpn
        delete params.authpt
        delete params.device_id
        delete params.device_name
        delete params.device_so
        delete params.format
        this.params = Object.assign(params, this.params);

        return params;
    }

    success(data, b) {
        this.resolve(data);
    }

}

export default OffersTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/cms/OffersTask.js